export interface VtoPerformanceTiming {
  detectionMs: number;
  qualityMs: number;
  semanticMs: number;
  calibrationMs: number;
  skinMs: number;
  complexionMs: number;
  cheekMs: number;
  eyeMs: number;
  lipMs: number;
  browMs: number;
  refinementMs: number;
  renderMs: number;
  totalMs: number;
}

export function emptyVtoPerformanceTiming(): VtoPerformanceTiming {
  return {
    detectionMs: 0,
    qualityMs: 0,
    semanticMs: 0,
    calibrationMs: 0,
    skinMs: 0,
    complexionMs: 0,
    cheekMs: 0,
    eyeMs: 0,
    lipMs: 0,
    browMs: 0,
    refinementMs: 0,
    renderMs: 0,
    totalMs: 0
  };
}

export function roundedMs(value: number): number {
  return Math.round(value);
}

export function vtoPerformanceWarnings(timing: VtoPerformanceTiming): string[] {
  const warnings: string[] = [];
  if (timing.totalMs > 8000) {
    warnings.push('VTO total time above 8000ms');
  } else if (timing.totalMs > 5000) {
    warnings.push('VTO total time above 5000ms');
  }
  if (timing.semanticMs > 1800) warnings.push('semantic parsing above 1800ms');
  if (timing.renderMs > 3000) warnings.push('render pipeline above 3000ms');
  if (timing.refinementMs > 900) warnings.push('refinement above 900ms');
  return warnings;
}
